import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { UserService } from '../../user/user.service';

const API_URL = environment.apiUrl;

@Injectable()
export class AuthService {
  constructor(private http: HttpClient, private userService: UserService) {}

  authenticate(login: any) {
    return this.http
      .post(API_URL + '/login_check', login, { observe: 'response' })
      .pipe(
        tap((res: any) => {
          const authToken = res.body.token;
          this.userService.setToken(authToken);
        })
      );
  }

  changePassword(body: any, userId: number) {
    return this.http
      .put(API_URL + '/users/' + userId + '/change-password', body, {
        observe: 'response',
      })
      .pipe(
        tap((res: any) => {
          const authToken = res.body.token;
          this.userService.setToken(authToken);
        })
      );
  }

  forgotPassword(body: any) {
    return this.http.post(API_URL + '/resetting-password-request', body);
  }

  forgotPasswordVerifyToken(token: string) {
    return this.http.get(
      API_URL + '/resetting-password-verify-token/' + token,
      {}
    );
  }

  forgotPasswordReset(body: any) {
    return this.http.post(API_URL + '/resetting-password-reset', body);
  }

  // editUser(body: any, userId: number) {
  //   return this.http.put(API_URL + '/users/' + userId, body);
  // }

  refreshToken() {
    return this.http
      .get(API_URL + '/refresh-token', { observe: 'response' })
      .pipe(
        tap((res: any) => {
          const authToken = res.body.token;
          this.userService.setToken(authToken);
        })
      );
  }

  authEventVerifyToken(token: string) {
    return this.http.get(API_URL + '/event-access-verify-token/' + token, {});
  }

  authEventPublicInspectionVerifyToken(token: string) {
    return this.http.get(API_URL + '/events/inspection-verify-token/' + token, {});
  }

  authEventPublicInspectionDeliveryVerifyToken(token: string) {
    return this.http.get(API_URL + '/events/inspection-delivery-verify-token/' + token, {});
  }

  authEventPublicQuotationVerifyToken(token: string) {
    return this.http.get(API_URL + '/events/quotation-verify-token/' + token, {});
  }

  authEventPublicThirdPartyVerifyToken(token: string) {
    return this.http.get(API_URL + '/events/third-party-verify-token/' + token, {});
  }

  authEventPublicDriverMonitoringVerifyToken(token: string) {
    return this.http.get(API_URL + '/events/driver-monitoring-verify-token/' + token, {});
  }

  authPaymentPublicVerifyToken(token: string) {
    return this.http.get(API_URL + '/payments/payment-public-verify-token/' + token, {});
  }
}
